export const ChooseCanvas = {
  CaptionTitle: {
    extends: ['Flex', 'CaptionTitle'],
    align: 'center',
    padding: 'X - - A',
    Text: {
      text: '{{ editor.chooseCanvas.select | polyglot }}',
      margin: '- C - -'
    },
    IconButton: {
      onClick: (ev, el) => el.call('openRouterModal', '/add-canvas'),
      theme: 'tertiary',
      icon: 'plus',
      ariaLabel: (el) => el.call('polyglot', 'editor.chooseCanvas.addCanvas'),
      margin: '- - - auto'
    },
    'IconButton.question': {
      theme: 'tertiary',
      icon: 'sf question',
      ariaLabel: (el) => el.call('polyglot', 'editor.editNavbar.openDocs'),
      onClick: (ev, el) => el.setWindow('docs', '/canvas-pages')
    }
  },
  Flex: {
    flow: 'y',
    gap: 'W2',
    margin: 'X2 - -',
    childProps: (el, s) => ({
      align: 'center',
      gap: 'Y',
      round: 'radiusPill',
      padding: 'Z A',
      isActive: s.value === el.call('getActiveCanvasPage'),
      theme: s.value === el.call('getActiveCanvasPage') ? 'field' : 'transparent',
      ':hover': {
        theme: 'field'
      },
      '!isActive': {
        color: 'inactive',
        fontWeight: '400'
      },
      '.isActive': {
        theme: 'field',
        fontWeight: '500',
        color: 'title'
      },
      Icon: {
        hide: (el, s) => !s._id,
        order: -1,
        name: 'url',
        color: 'blue.35'
      },
      Text: {
        text: '{{ value }}'
      },
      SharedLibSuffix: {
        hide: (el, s) => !s._id,
        margin: '- - - -X2',
        opacity: '.35',
        text: '.symbo.ls'
      },
      Icon_arrow: {
        hide: (el, s) => !s._id,
        margin: '- - - auto',
        name: 'arrowUpRight',
        color: 'disabled'
      },
      onClick: async (ev, el, s) => {
        if (s._id) {
          // Same-origin canvas route — navigate in-app via the SPA router
          // instead of spawning a new tab (sibling branches below already
          // route in-shell via openCanvasPage / openRouterModal).
          return el.router(`/nikoloza/${s.value}`, el.getRoot())
        }
        if (el.getWindow('explorerMinimized')) {
          el.expandWindow('explorer')
        } else if (s.value === 'Add new') {
          await el.call('openRouterModal', '/add-canvas')
        } else {
          await el.call('openCanvasPage', s.value)
        }
      }
    }),
    childExtends: {
      onContextmenu: (ev, el) => {
        const data = el.scope
        if (!data) {
          return
        }
        window.requestAnimationFrame(() => {
          el.activateContext(ev, el)
        })
      }
    },
    childrenAs: 'state',
    children: async (el, s) => {
      // `canvas` is absent in any host that never opened one (UI-kit
      // catalog, preview frame, a fresh shell). The optional hop belongs
      // BEFORE the dot: `canvas.pages || {}` still throws on `canvas`.
      const { canvas } = el.getRootState() || {}
      // `el.call` answers undefined for a name this host never registered
      // (framework contract, smbls element methods.js) — and a children
      // factory MUST answer an array, or the reconciler takes the whole
      // dropdown down with an unhandled rejection.
      const rows =
        el.call(
          'joinArrays',
          [
            {
              title: (el) => el.call('polyglot', 'editor.chooseCanvas.default')
            },
            ...Object.values(canvas?.pages || {})
          ],
          s.sharedLibs || []
        ) || []
      return rows.map((v) => ({
        value: v.title,
        ...v
      }))
    },
    onRender: (el, s) => {
      if (el.isEmbed()) {
        return
      }
      window.requestAnimationFrame(async () => {
        // const mySharedLibs = await el.call('getMySharedLibraries')
        // const sharedLibs = mySharedLibs.map(lib => ({
        //   title: lib.key.split('.symbo.ls')[0],
        //   _id: lib.id,
        //   key: lib.key,
        //   name: lib.name,
        //   ...lib
        // }))
        // s.replace({
        //   sharedLibs
        // })
      })
    }
  }
}
